/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import userActions from '../../../redux/actions/userActions';
import uiActions from '../../../redux/actions/uiActions';

const ProfileMenu = ({
  anchorEl, logout, changeDarkMode, handleMenuClose, darkMode,
}) => {
  const profilMenuId = 'account-menu';
  const [menuRedirect, setmenuRedirect] = useState(false);

  useEffect(() => {
    setmenuRedirect(false);
  }, [menuRedirect]);

  function goToProfile() {
    setmenuRedirect(true);
    handleMenuClose();
  }

  return (
    <Menu
      anchorEl={anchorEl}
      id={profilMenuId}
      role="menu"
      aria-label="Menu du profil utilisateur"
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
    >
      <MenuItem role="menuitem" aria-label="Voir le profil" onClick={() => goToProfile()}>Profile</MenuItem>
      {
        menuRedirect && <Redirect to="/profile" />
      }
      <div style={{ width: '100%' }}>
        <FormControlLabel
          value="start"
          style={{ paddingRight: '10px' }}
          control={<Switch onClick={() => changeDarkMode(!darkMode)} checked={darkMode} color="primary" />}
          label="Dark mode"
          labelPlacement="start"
        />
      </div>
      <Divider />
      <MenuItem role="menuitem" aria-label="Se déconnecter" onClick={() => logout()}>Logout</MenuItem>
    </Menu>
  );
};

ProfileMenu.defaultProps = {
  anchorEl: null,
};

ProfileMenu.propTypes = {
  anchorEl: PropTypes.any,
  logout: PropTypes.func.isRequired,
  changeDarkMode: PropTypes.func.isRequired,
  handleMenuClose: PropTypes.func.isRequired,
  darkMode: PropTypes.bool.isRequired,
};

function mapState(state) {
  const { currentPage, darkMode } = state.ui;
  return {
    currentPage, darkMode,
  };
}

const actionCreator = {
  logout: userActions.logout,
  changeDarkMode: uiActions.changeDarkMode,
};

export default connect(mapState, actionCreator)(ProfileMenu);
